import React from "react";
import styles from "./start-page.module.css";
import {Page} from "../../components/page/page";
import video from "./witch-bg.mp4";

const StartPage = () => {
  const titleWithSlider = (
    <div className={styles.title}>
      Do You Possess Witch-Like Powers?
    </div>
  );
  return (
    <div className={styles.bg_start_page}>
      <Page
        title={titleWithSlider}
        nextPageLink="./magical-insight"
        hideSteps={true}
        btnText="Take the quiz"
      >
        <video loop={true} muted={true} playsInline={true} autoPlay={true} className={styles.video_bg}>
          <source src={video} type="video/mp4" />
        </video>
      </Page>
    </div>
  );
};

export { StartPage };
